/* Custom: shows a line item block only while a variant option is set to a
   trigger value (for example "Custom"). Every form control inside is disabled
   while hidden, so nothing is submitted and required fields cannot block the
   form. */

class LineItemConditional extends HTMLElement {
    #boundUpdate;
    #variantSelectors;
    #controls;
    #active=null;
    constructor() {
        super();
        this.#boundUpdate = this.update.bind(this);
    }
    connectedCallback() {
        this.triggers = (this.dataset.triggerValues || "").split(",").map((value => value.trim().toLowerCase())).filter(Boolean);
        this.optionName = (this.dataset.optionName || "").trim().toLowerCase();
        this.#controls = Array.from(this.querySelectorAll("input, select, textarea")).map((element => ({
            element: element,
            required: element.required
        })));
        const scope = this.closest("product-single, quick-shop") || document;
        this.#variantSelectors = scope.querySelector("variant-selects, variant-radios, variant-mixed-inputs");
        if (this.#variantSelectors) {
            this.#variantSelectors.addEventListener("change", this.#boundUpdate);
        }
        document.addEventListener("variant:changed", this.#boundUpdate);
        this.update();
    }
    disconnectedCallback() {
        if (this.#variantSelectors) {
            this.#variantSelectors.removeEventListener("change", this.#boundUpdate);
        }
        document.removeEventListener("variant:changed", this.#boundUpdate);
    }
    get selectedOptions() {
        if (!this.#variantSelectors) return [];
        const selects = Array.from(this.#variantSelectors.querySelectorAll("select"), (select => ({
            name: select.name.replace("options[", "").replace("]", "").trim().toLowerCase(),
            value: (select.value || "").trim().toLowerCase()
        })));
        const radios = Array.from(this.#variantSelectors.querySelectorAll('input[type="radio"]:checked'), (radio => ({
            name: radio.name.trim().toLowerCase(),
            value: (radio.value || "").trim().toLowerCase()
        })));
        return [ ...selects, ...radios ];
    }
    get shouldShow() {
        if (!this.triggers.length) return true;
        return this.selectedOptions.some((({name: name, value: value}) => {
            if (this.optionName && name !== this.optionName) return false;
            return this.triggers.includes(value);
        }));
    }
    update() {
        const active = this.shouldShow;
        if (active === this.#active) return;
        this.#active = active;
        this.hidden = !active;
        this.#controls.forEach((({element: element, required: required}) => {
            if (active) {
                element.disabled = false;
                if (required) element.required = true;
            } else {
                element.required = false;
                element.disabled = true;
            }
        }));
        this.dispatchEvent(new CustomEvent("on:line-item-conditional:toggle", {
            bubbles: true,
            detail: {
                active: active
            }
        }));
    }
}

customElements.define("line-item-conditional", LineItemConditional);
